module.exports = __webpack_public_path__ + "static/img/qrCode.ddb41cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/qrCode.png
// module id = APUL
// module chunks = 46